// maplibre-gl 6 resolves its worker through import.meta.url, which a bundler cannot follow: without this the map paints only its background.
import * as maplibregl from 'maplibre-gl';
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

maplibregl.setWorkerUrl(maplibreWorkerUrl);
